import React, { useEffect, useState } from 'react'
import './Home.css'
import Table from '../Components/Table'
import { NavLink } from 'react-router-dom'

const Home = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const apikey = process.env.REACT_APP_API_KEY;
  const currentDate = new Date().toLocaleDateString('en-CA');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `https://financialmodelingprep.com/api/v4/commitment_of_traders_report?from=2020-09-12&to=2023-07-20&apikey=${apikey}`
        );
        const jsonData = await response.json();
        setData(jsonData);
        setIsLoading(false);
      } catch (error) {
        console.error('Error fetching data:', error);
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  const dataBySector = data.reduce((acc, curr) => {
    const sector = curr.sector;
    if (sector !== "0") {
      if (!acc[sector]) {
        acc[sector] = [];
      }
      acc[sector].push(curr);
    }
    return acc;
  }, {});


  return (
    <div className='home'>
      <div className="header p-sm-5 p-2 pt-5 pb-5">
        <div className="headercontent">
          <h1 className="heading">Charting Tools for In-Depth Analysis of Commitment of Traders (COT) Reports</h1>
          <h4 className="subheading">Unlock the power of Commitment of Traders (COT) report analysis with our interactive charting tools for better trading decisions.
          </h4>
          <NavLink className="legacy" to="/cot/futures">
            <button className="home-btn">FREE COT CHARTS</button></NavLink>
        </div>
      </div>
      <div className="cottables p-4 p-sm-5">
        {isLoading ? (
          <div><img src="./loading1.gif" alt="" /></div>
        ) : (
          <div className="tables">
            {Object.entries(dataBySector).map(([sector, sectorData]) => (
              <Table key={sector} data={sectorData} sector={sector} />
            ))}
          </div>
        )}
      </div>
    </div>
  )
}

export default Home